import { v4 as uuid } from "uuid";
import { ProductState } from "../store/chart";

let session = uuid();

type PixelData = { [key: string]: any };

export type PixelFn = (
  eventType: string,
  eventName: string,
  product: PixelData,
) => void;

const getProductData = (product: ProductState): PixelData => {
  return {
    uuid: product.id,
    product_kind: product.productKindId,
    name: product.name,
    sku: product.sku,
    explore_sku: product.exploreSku,
    link: product.shopUrl,
    desktop_preselected: product.desktopPreselected,
    mobile_preselected: product.mobilePreselected,
  };
};

const onChartLoad = (_pixel: PixelFn = () => {}) => {
  session = uuid();
};

const onProductSelect = (pixel: PixelFn = () => {}, product: ProductState) => {
  pixel("event", "productSelect", {
    session,
    product: getProductData(product),
  });
};

const onProductUnselect = (
  pixel: PixelFn = () => {},
  product: ProductState,
) => {
  pixel("event", "productUnselect", {
    session,
    product: getProductData(product),
  });
};

const onShopClick = (pixel: PixelFn = () => {}, product: ProductState) => {
  pixel("event", "productShopClick", {
    session,
    product: getProductData(product),
  });
};

const onShopSelectClick = (
  pixel: PixelFn = () => {},
  product: ProductState,
) => {
  pixel("event", "productShopSelectClick", {
    session,
    product: getProductData(product),
  });
};

const pixel = {
  onChartLoad,
  onProductSelect,
  onProductUnselect,
  onShopClick,
  onShopSelectClick,
};

export default pixel;
